import axios from 'axios'

export const rightsImage = function (rurl) {
  let rightsimage = ''
  let rightstitle = ''
  let rimage = ''

  if (rurl.indexOf('europeana.eu/rights') > -1) {
    if (rurl.indexOf('/rr-f') > -1) {
      rightstitle = 'Rights Reserved - Free access'
      rightsimage = 'static/rights/eu_free_access.jpg'
    } else if (rurl.indexOf('/rr-p') > -1) {
      rightstitle = 'Rights Reserved - Paid access'
      rightsimage = 'static/rights/eu_paid_access.jpg'
    } else if (rurl.indexOf('/rr-r') > -1) {
      rightstitle = 'Rights Reserved - Restricted access'
      rightsimage = 'static/rights/eu_restricted_access.jpg'
    } else if (rurl.indexOf('/unknown') > -1) {
      rightstitle = 'Unknown'
      rightsimage = 'static/rights/eu_unknown.jpg'
    }
  } else if (rurl.indexOf('creativecommons.org') > -1) {
    if (rurl.indexOf('publicdomain/mark/1.0/') > -1) {
      rightstitle = 'Public Domain Mark - No Known Copyright'
      rightsimage = 'static/rights/noc.png'
    } else if (rurl.indexOf('publicdomain/zero/1.0') > -1) {
      rightstitle = 'CC0 - No Rights Reserved'
      rightsimage = 'static/rights/cc0.png'
    } else if (rurl.indexOf('/by/') > -1) {
      rightstitle = 'CC BY  Attribution'
      rightsimage = 'static/rights/cc-by.png'
    } else if (rurl.indexOf('/by-sa/') > -1) {
      rightstitle = 'CC BY-SA Attribution-ShareAlike'
      rightsimage = 'static/rights/cc-by-sa.png'
    } else if (rurl.indexOf('/by-nc/') > -1) {
      rightstitle = 'CC BY-NC Attribution, Non-Commercial'
      rightsimage = 'static/rights/cc-by-nc.png'
    } else if (rurl.indexOf('/by-nd/') > -1) {
      rightstitle = 'CC BY-ND Attribution, No Derivatives'
      rightsimage = 'static/rights/cc-by-nd.png'
    } else if (rurl.indexOf('/by-nc-nd/') > -1) {
      rightstitle = 'CC BY-NC-ND Attribution, Non-Commercial, No Derivatives'
      rightsimage = 'static/rights/cc-by-nc-nd.png'
    } else if (rurl.indexOf('/by-nc-sa/') > -1) {
      rightstitle = 'CC BY-NC-SA Attribution, Non-Commercial, ShareAlike'
      rightsimage = 'static/rights/cc-by-nc-sa.png'
    }
  } else {
    rightstitle = rurl
  }

  if (rightsimage.length > 0) {
    rimage = '<a href="' + rurl + '" target="_blank" title="' + rightstitle + '"><img src="/' + rightsimage + '"/></a>'
  } else {
    rimage = '<a href="' + rurl + '" target="_blank" title="' + rightstitle + '">' + rurl + '</a>'
  }
  return {
    img: rimage,
    title: rightstitle
  }
}

export const findProviderImage = function (provider) {
  let im = ''
  provider = provider.toLowerCase().trim()

  if (provider.indexOf('amsterdam') > -1) {
    im = '/static/provider/AMSTERDAM_MUSEUM_n.PNG'
  } else if (provider.indexOf('armémuseum') > -1) {
    im = '/static/provider/amremmuseum_n.png'
  } else if (provider.indexOf('cer.es') > -1) {
    im = '/static/provider/TRAJE_n.png'
  } else if (provider.indexOf('catwalkpictures') > -1) {
    im = '/static/provider/CATWALK_n.png'
  } else if (provider.indexOf('centraal') > -1) {
    im = '/static/provider/CENTRAL_MUSEUM_n.png'
  } else if (provider.indexOf('fondazione cerratelli') > -1) {
    im = '/static/provider/cerratelli_n.png'
  } else if (provider.indexOf('fries') > -1) {
    im = '/static/provider/FRIESMUSEUM_n.png'
  } else if (provider.indexOf('galleria del costume') > -1) {
    im = '/static/provider/polo_museale_fiorentino_n.png'
  } else if (provider.indexOf('gemeentemuseum') > -1) {
    im = '/static/provider/Gemeentemuseum_.png'
  } else if (provider.indexOf('university of antwerp') > -1) {
    im = '/static/provider/HERITAGE_n.png'
  } else if (provider.indexOf('kmkg') > -1) {
    im = '/static/provider/MUSEUM_BRUSSEL_n.png'
  } else if (provider.indexOf('kunstbibliothek') > -1) {
    im = '/static/provider/Kunstbibliothek_Berlin_n.png'
  } else if (provider.indexOf('décoratifs') > -1) {
    im = '/static/provider/MAD_n.png'
  } else if (provider.indexOf('mude') > -1) {
    im = '/static/provider/MUDE_n.png'
  } else if (provider.indexOf('missoni') > -1) {
    im = '/static/provider/MISSONI_n.png'
  } else if (provider.indexOf('modemuseum hasselt') > -1) {
    im = '/static/provider/Modemuseum_Hasselt_n.png'
  } else if (provider.indexOf('ferragamo') > -1) {
    im = '/static/provider/SALVATORE_FERRAGAMO_n.png'
  } else if (provider.indexOf('applied art') > -1) {
    im = '/static/provider/muap_n.png'
  } else if (provider.indexOf('peloponnesian folklore') > -1) {
    im = '/static/provider/PFF_n.png'
  } else if (provider.indexOf('pitti') > -1) {
    im = '/static/provider/PITTI_IMMAGINE_n.png'
  } else if (provider.indexOf('pucci') > -1) {
    im = '/static/provider/PUCCI_n.png'
  } else if (provider.indexOf('rossimoda') > -1) {
    im = '/static/provider/MUSEO_ABALDI_n.png'
  } else if (provider.indexOf('shoes or no shoes') > -1) {
    im = '/static/provider/shoesornoshoes_n.png'
  } else if (provider.indexOf('stichting nationaal museum van wereldculturen') > -1) {
    im = '/static/provider/TROPEN_n.png'
  } else if (provider.indexOf('wereldculturen') > -1) {
    im = '/static/provider/wereldmusea.jpg'
  } else if (provider.indexOf('textile research centre leiden') > -1) {
    im = '/static/provider/TRC_n.png'
  } else if (provider.indexOf('nordiska') > -1) {
    im = '/static/provider/NORDISKA_n.png'
  } else if (provider.indexOf('stockholm') > -1) {
    im = '/static/provider/STOCKHOLM_n.png'
  } else if (provider.indexOf('textielmuseum') > -1) {
    im = '/static/provider/TEXTIEL_MUSEUM_n.png'
  } else if (provider.indexOf('textiles') > -1) {
    im = '/static/provider/textiles.png'
  } else if (provider.indexOf('the israel museum') > -1) {
    im = '/static/provider/MOYO_n.png'
  } else if (provider.indexOf('theatercollectie bijzondere') > -1) {
    im = '/static/provider/BC_KLEIN.PNG'
  } else if (provider.indexOf('victoria') > -1) {
    im = '/static/provider/VICTORIA_MUSEUM_n.png'
  } else if (provider.indexOf('wien') > -1) {
    im = '/static/provider/WIEN_n.png'
  } else if (provider.indexOf('sound and vision') > -1) {
    im = '/static/provider/NISV_n.png'
  } else if (provider.indexOf('berg') > -1) {
    im = '/static/provider/berg.png'
  } else if (provider.indexOf('fondazione gianfranco') > -1) {
    im = '/static/provider/FondazioneFerre.jpg'
  } else if (provider.indexOf('rotterdam') > -1) {
    im = '/static/provider/mm.jpg'
  } else if (provider.indexOf('spk') > -1) {
    im = '/static/provider/spk.jpg'
  } else if (provider.indexOf('benetton') > -1) {
    im = '/static/provider/BENETTON.PNG'
  } else if (provider.indexOf('germanisches') > -1) {
    im = '/static/provider/Germanisches.PNG'
  } else if (provider.indexOf('gianfranco') > -1) {
    im = '/static/provider/GIANFRANCO_FERRE.PNG'
  } else if (provider.indexOf('its') > -1) {
    im = '/static/provider/ITS_n.png'
  } else if (provider.indexOf('arts décoratifs') > -1) {
    im = '/static/provider/MAD.PNG'
  } else if (provider.indexOf('modemuseum provincie antwerpen') > -1) {
    im = '/static/provider/MODERN_MUSEUM_n.png'
  } else if (provider.indexOf('moyo') > -1) {
    im = '/static/provider/MOYO.PNG'
  } else if (provider.indexOf('brussel') > -1) {
    im = '/static/provider/MUSEUM_BRUSSEL.PNG'
  } else if (provider.indexOf('openluchtmuseum') > -1) {
    im = '/static/provider/Openlucht-museum_n.png'
  } else if (provider.indexOf('fiorentino') > -1) {
    im = '/static/provider/polo_museale_fiorentino.PNG'
  } else if (provider.indexOf('paul van riel') > -1) {
    im = '/static/provider/PVR_VintageFashion_n.png'
  } else if (provider.indexOf('kartenabteilung') > -1) {
    im = '/static/provider/STIFTUNG_n.png'
  } else if (provider.indexOf('royal library of belgium') > -1) {
    im = '/static/provider/KBR_n.png'
  }

  return im
}

export const findProviderLink = function (provider) {
  let im = ''
  provider = provider.toLowerCase().trim()

  if (provider.indexOf('amsterdam') > -1) {
    im = 'https://www.amsterdammuseum.nl/'
  } else if (provider.indexOf('armémuseum') > -1) {
    im = 'http://www.armemuseum.se/'
  } else if (provider.indexOf('cer.es') > -1) {
    im = 'http://ceres.mcu.es/'
  } else if (provider.indexOf('catwalkpictures') > -1) {
    im = 'https://www.catwalkpictures.com/'
  } else if (provider.indexOf('centraal') > -1) {
    im = 'https://centraalmuseum.nl/'
  } else if (provider.indexOf('fondazione cerratelli') > -1) {
    im = 'http://www.fondazionecerratelli.it/'
  } else if (provider.indexOf('fries') > -1) {
    im = 'https://www.friesmuseum.nl/en/'
  } else if (provider.indexOf('galleria del costume') > -1) {
    im = 'http://www.polomuseale.firenze.it/'
  } else if (provider.indexOf('gemeentemuseum') > -1) {
    im = 'https://www.gemeentemuseum.nl/en'
  } else if (provider.indexOf('university of antwerp') > -1) {
    im = 'https://www.uantwerpen.be/en/research-groups/heritage-and-sustainability/'
  } else if (provider.indexOf('kmkg') > -1) {
    im = 'http://www.kmkg-mrah.be/'
  } else if (provider.indexOf('kunstbibliothek') > -1) {
    im = 'https://www.smb.museum/en/home.html'
  } else if (provider.indexOf('décoratifs') > -1) {
    im = 'http://madparis.fr/'
  } else if (provider.indexOf('mude') > -1) {
    im = 'http://www.mude.pt/'
  } else if (provider.indexOf('missoni') > -1) {
    im = 'http://www.missoni.com'
  } else if (provider.indexOf('modemuseum hasselt') > -1) {
    im = 'http://www.modemuseumhasselt.be/'
  } else if (provider.indexOf('modemuseum') > -1) {
    im = 'https://www.momu.be'
  } else if (provider.indexOf('ferragamo') > -1) {
    im = 'https://www.ferragamo.com/museo/'
  } else if (provider.indexOf('applied art') > -1) {
    im = 'http://mpu.rs/en/'
  } else if (provider.indexOf('peloponnesian folklore') > -1) {
    im = 'http://www.pli.gr/'
  } else if (provider.indexOf('pitti') > -1) {
    im = 'http://www.pittimmagine.com/'
  } else if (provider.indexOf('pucci') > -1) {
    im = 'https://www.emiliopucci.com/'
  } else if (provider.indexOf('rossimoda') > -1) {
    im = 'http://www.museodellacalzatura.it/'
  } else if (provider.indexOf('shoes or no shoes') > -1) {
    im = 'http://www.shoesornoshoes.com/'
  } else if (provider.indexOf('stichting nationaal museum van wereldculturen') > -1) {
    im = 'http://museumovermensen.nl/'
  } else if (provider.indexOf('wereldculturen') > -1) {
    im = 'http://museumovermensen.nl/'
  } else if (provider.indexOf('textile research centre leiden') > -1) {
    im = 'https://www.trc-leiden.nl/'
  } else if (provider.indexOf('nordiska') > -1) {
    im = 'https://www.nordiskamuseet.se/en'
  } else if (provider.indexOf('stockholm') > -1) {
    im = 'https://www.su.se/english/'
  } else if (provider.indexOf('textielmuseum') > -1) {
    im = 'https://www.textielmuseum.nl/en/'
  } else if (provider.indexOf('textiles') > -1) {
    im = 'https://www.trc-leiden.nl/'
  } else if (provider.indexOf('the israel museum') > -1) {
    im = 'https://www.imj.org.il/en/'
  } else if (provider.indexOf('theatercollectie bijzondere') > -1) {
    im = 'http://bijzonderecollecties.uva.nl/en/'
  } else if (provider.indexOf('victoria') > -1) {
    im = 'https://www.vam.ac.uk/'
  } else if (provider.indexOf('wien') > -1) {
    im = 'https://www.wienmuseum.at/en.html'
  } else if (provider.indexOf('sound and vision') > -1) {
    im = 'https://beeldengeluid.nl/en'
  } else if (provider.indexOf('berg') > -1) {
  //   im = ''
  // } else if (provider.indexOf('fondazione gianfranco') > -1) {
  //   im = ''
  // } else if (provider.indexOf('rotterdam') > -1) {
  //   im = ''
  // } else if (provider.indexOf('spk') > -1) {
  //   im = ''
  // } else if (provider.indexOf('benetton') > -1) {
  //   im = ''
  // } else if (provider.indexOf('germanisches') > -1) {
  //   im = ''
  // } else if (provider.indexOf('gianfranco') > -1) {
  //   im = ''
  } else if (provider.indexOf('its') > -1) {
    im = 'http://www.itsweb.org/'
  // } else if (provider.indexOf('arts décoratifs') > -1) {
  //   im = ''
  } else if (provider.indexOf('modemuseum provincie antwerpen') > -1) {
    im = 'MODERN_MUSEUM_n.png'
  // } else if (provider.indexOf('moyo') > -1) {
  //   im = ''
  } else if (provider.indexOf('brussel') > -1) {
    im = 'http://www.kmkg-mrah.be/'
  } else if (provider.indexOf('openluchtmuseum') > -1) {
    im = 'http://www.openluchtmuseum.nl'
  } else if (provider.indexOf('fiorentino') > -1) {
    im = 'http://www.polomuseale.firenze.it/'
  } else if (provider.indexOf('paul van riel') > -1) {
    im = 'http://www.paulvanriel.com/'
  } else if (provider.indexOf('kartenabteilung') > -1) {
    im = 'https://staatsbibliothek-berlin.de/'
  } else if (provider.indexOf('royal library of belgium') > -1) {
    im = 'https://www.kbr.be/en'
  }

  return im
}

export const endsWith = function (str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1
}

export const resultGalleryElement = function (container, item) {
  if (/player\.vimeo\.com/.test(item.uri)) {
    container.append('<div class="video vimeo"><div class="wrap"><iframe src="' + item.uri + '" frameborder="0" allowfullscreen="true"></iframe></div></div>')
  } else {
    /*
    let imaged = $('<div>').addClass('image');
    let thumbnail = '<div class="graphic"><img src="' + item.uri + '" thumb-src="' + item.uri + '?thumb=horizontal" onError="imgError(this,\'IMAGEDETAIL\')" /></div>'
    imaged.append(thumbnail)
    container.append(imaged)
    */
  }
}

export const truncateLongText = function (text, length) {
  if (text.length > length) {
    let s_ = text.substr(0, length - 1)
    s_ = s_.substr(0, s_.lastIndexOf(' '))
    return s_
  } else {
    return text
  }
}

export const hasPropertyWithValues = function (property) {
  if (!(property !== undefined && property.values !== undefined && property.values.length > 0)) return false
  for (let i in property.values) {
    let value = property.values[i]
    if (value.text !== undefined && value.text.length > 0) return true
    if (value.uri !== undefined && value.uri.length > 0) return true
    if (value.name !== undefined && value.name.length > 0) return true
    if (value.altName !== undefined && value.altName.length > 0) return true

    if (value.prefLabel !== undefined && value.prefLabel.values.length > 0) {
      for (let j in value.prefLabel.values) {
        if (value.prefLabel.values[j].text !== undefined && value.prefLabel.values[j].text.length > 0) return true
      }
    }
    if (value.altLabel !== undefined && value.altLabel.values.length > 0) {
      for (let j in value.altLabel.values) {
        if (value.altLabel.values[j].text !== undefined && value.altLabel.values[j].text.length > 0) return true
      }
    }
  }

  return false
}

export const itemDetailsJSON = function (result) {
  let htmlstr = []
  let itemprovider = ''
  let itemcreator = ''
  let itemtype = ''
  let lang = 'en'
  let doctitle = ''
  let creator = ''
  let designer = ''

  // Title & Description

  if (result.title !== undefined) {
    doctitle = findByLangTitle(lang, result)
    document.title = doctitle
  } else if (result.description !== undefined) {
    doctitle = findByLangValues(lang, result.description.values)
    document.title = doctitle
  }

  if (hasPropertyWithValues(result.description)) {
    // $("#tabObjInfo").find("div.textblock").html("<p>" + findByLangValues(lang, result.description.values) + "</p>")
  }

  if (hasPropertyWithValues(result.identifier)) {
    htmlstr.push('<div class="spec spec-identifier"><div class="label" lang="en">Identifier</div><div class="value">' + findByLangValues(lang, result.identifier.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.alternative)) {
    htmlstr.push('<div class="spec spec-alternative-title"><div class="label" lang="en">Alternative title</div><div class="value">' + findByLangValues(lang, result.alternative.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.date)) {
    htmlstr.push('<div class="spec spec-creation-date"><div class="label" lang="en">Creation date</div><div class="value">' + findByLangValues(lang, result.date.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.issued)) {
    htmlstr.push('<div class="spec spec-pubblication-date"><div class="label" lang="en">Publication date</div><div class="value">' + findByLangValues(lang, result.issued.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.medium)) {
    htmlstr.push('<div class="spec spec-material"><div class="label" lang="en">Material</div><div class="value">' + findByLangThesauriValues(lang, result.medium.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.language)) {
    htmlstr.push('<div class="spec spec-language"><div class="label" lang="en">Language</div><div class="value">' + findByLangValues(lang, result.language.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.provenance)) {
    htmlstr.push('<div class="spec spec-provenance"><div class="label" lang="en">Provenance</div><div class="value">' + findByLangValues(lang, result.provenance.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.coverage)) {
    htmlstr.push('<div class="spec spec-place"><div class="label" lang="en">Place</div><div class="value">' + findByLangSpatial(lang, result.coverage.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.coverageTimespan)) {
    htmlstr.push('<div class="spec spec-timestamp"><div class="label" lang="en">Timespan</div><div class="value">' + findByLangSpatial(lang, result.coverageTimespan.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.spatial)) {
    htmlstr.push('<div class="spec spec-place"><div class="label" lang="en">Place</div><div class="value">' + findByLangSpatial(lang, result.spatial.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.temporal)) {
    htmlstr.push('<div class="spec spec-period"><div class="label" lang="en">Period</div><div class="value">' + findByLangValues(lang, result.temporal.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.dsr)) {
    designer = findByLangAgent(lang, result.dsr.values)

    htmlstr.push('<div class="spec spec-designer"><div class="label" lang="en">Designer</div><div class="value">' + designer + '</div></div>')
    itemcreator = result.dsr.values[0].prefLabel.values[0].text
  }
  if (hasPropertyWithValues(result.creator)) {
    creator = findByLangAgent(lang, result.creator.values)
    if (designer !== creator) {
      htmlstr.push('<div class="spec spec-creator"><div class="label" lang="en">Creator</div><div class="value">' + creator + '</div></div>')
    }
    if (itemcreator.length === 0 && result.creator.values[0].prefLabel.values) {
      itemcreator = result.creator.values[0].prefLabel.values[0].text
    }
  }
  if (hasPropertyWithValues(result.publisher)) {
    htmlstr.push('<div class="spec spec-publisher"><div class="label" lang="en">Publisher</div><div class="value">' + findByLangAgent(lang, result.publisher.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.format)) {
    htmlstr.push('<div class="spec spec-format"><div class="label" lang="en">Format</div><div class="value">' + findByLangValues(lang, result.format.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.extent)) {
    htmlstr.push('<div class="spec spec-size-duration"><div class="label" lang="en">Size or duration</div><div class="value">' + findByLangValues(lang, result.extent.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.subject)) {
    htmlstr.push('<div class="spec spec-subject"><div class="label" lang="en">Subject</div><div class="value">' + findByLangThesauriValues(lang, result.subject.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.type)) {
    htmlstr.push('<div class="spec spec-object-type"><div class="label" lang="en">Object Type</div><div class="value">' + findByLangThesauriValues(lang, result.type.values) + '</div></div>')
    itemtype = result.type.values[0].uri
  }
  if (hasPropertyWithValues(result.localType)) {
    htmlstr.push('<div class="spec spec-original-object-type"><div class="label" lang="en">Original object type</div><div class="value">' + findByLangValues(lang, result.localType.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.makeUpArtist)) {
    htmlstr.push('<div class="spec spec-makeup-artist"><div class="label" lang="en">Makeup Artist</div><div class="value">' + findByLangAgent(lang, result.makeUpArtist.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.model)) {
    htmlstr.push('<div class="spec spec-model"><div class="label" lang="en">Model</div><div class="value">' + findByLangAgent(lang, result.model.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.stylist)) {
    htmlstr.push('<div class="spec spec-stylist"><div class="label" lang="en">Stylist</div><div class="value">' + findByLangAgent(lang, result.stylist.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.hairstylist)) {
    htmlstr.push('<div class="spec spec-hairstylist"><div class="label" lang="en">Hairstylist</div><div class="value">' + findByLangAgent(lang, result.hairstylist.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.technique)) {
    htmlstr.push('<div class="spec spec-technique"><div class="label" lang="en">Technique</div><div class="value">' + findByLangThesauriValues(lang, result.technique.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.color)) {
    htmlstr.push('<div class="spec spec-color"><div class="label" lang="en">Color</div><div class="value">' + findByLangThesauriValues(lang, result.color.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.aut)) {
    htmlstr.push('<div class="spec spec-author"><div class="label" lang="en">Author</div><div class="value">' + findByLangAgent(lang, result.aut.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.clb)) {
    htmlstr.push('<div class="spec spec-collaborator"><div class="label" lang="en">Collaborator</div><div class="value">' + findByLangAgent(lang, result.clb.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.cur)) {
    htmlstr.push('<div class="spec spec-curator"><div class="label" lang="en">Curator</div><div class="value">' + findByLangAgent(lang, result.cur.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.dir)) {
    htmlstr.push('<div class="spec spec-director"><div class="label" lang="en">Director</div><div class="value">' + findByLangAgent(lang, result.dir.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.drt)) {
    htmlstr.push('<div class="spec spec-director"><div class="label" lang="en">Director</div><div class="value">' + findByLangAgent(lang, result.drt.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.edt)) {
    htmlstr.push('<div class="spec spec-editor"><div class="label" lang="en">Editor</div><div class="value">' + findByLangAgent(lang, result.edt.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.ill)) {
    htmlstr.push('<div class="spec spec-illustrator"><div class="label" lang="en">Illustrator</div><div class="value">' + findByLangAgent(lang, result.ill.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.ive)) {
    htmlstr.push('<div class="spec spec-interviewee"><div class="label" lang="en">Interviewee</div><div class="value">' + findByLangAgent(lang, result.ive.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.ivr)) {
    htmlstr.push('<div class="spec spec-interviewer"><div class="label" lang="en">Interviewer</div><div class="value">' + findByLangAgent(lang, result.ivr.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.pht)) {
    htmlstr.push('<div class="spec spec-photographer"><div class="label" lang="en">Photographer</div><div class="value">' + findByLangAgent(lang, result.pht.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.pro)) {
    htmlstr.push('<div class="spec spec-producer"><div class="label" lang="en">Producer</div><div class="value">' + findByLangAgent(lang, result.pro.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.sds)) {
    htmlstr.push('<div class="spec spec-sound-designer"><div class="label" lang="en">Sound designer</div><div class="value">' + findByLangAgent(lang, result.sds.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.spn)) {
    htmlstr.push('<div class="spec spec-sponsor"><div class="label" lang="en">Sponsor</div><div class="value">' + findByLangAgent(lang, result.spn.values) + '</div></div>')
  }
  if (hasPropertyWithValues(result.std)) {
    htmlstr.push('<div class="spec spec-set-designer"><div class="label" lang="en">Set Designer</div><div class="value">' + findByLangAgent(lang, result.std.values) + '</div></div>')
  }
  /*
  if (hasPropertyWithValues(result.dcrights) || hasPropertyWithValues(result.edmrights)) {
    htmlstr.push('<div class="spec spec-rights-statement"><div class="label" lang="en">Rights statement</div>')
    if (hasPropertyWithValues(result.dcrights)) {
      htmlstr += '<div class="value">' + findByLangValues(lang, result.dcrights.values) + '</div>'
    }
    if (hasPropertyWithValues(result.edmrights)) {
      htmlstr += '<div class="value">' + rightsImage(findByLangRights(lang, result.edmrights.values))
      if (result.isShownAt !== undefined && result.isShownAt.values !== undefined && result.isShownAt.values.length > 0 && result.isShownAt.values[0].text !== undefined && result.isShownAt.values[0].text.length > 0) {
        htmlstr += '<br/>' + result.isShownAt.values[0].text
      }
      htmlstr += '</div>'
    }
    htmlstr += '</div>'
  }
  */

  if (result.isShownAt !== undefined && result.isShownAt.values !== undefined && result.isShownAt.values.length > 0) {
    /*
    let providertext = ''
    if (result.dataProvider !== undefined) {
      providertext = findByLangAgent(lang, result.dataProvider.values)
    }
    */

    if (result.isShownAt.values[0].uri !== undefined) {
      if (result.dataProvider !== undefined) {
        if (findByLangAgent(lang, result.dataProvider.values) === 'Stockholm University') {
          htmlstr.push('<div class="spec spec-webpage"><div class="label" lang="en">Original webpage</div><div class="value">' +
            '<a href="' + result.isShownAt.values[0].uri + '" target="blank">Original website</a></div></div>')
        } else {
          htmlstr.push('<div class="spec spec-webpage"><div class="label" lang="en">Original webpage</div><div class="value">' +
            '<a href="' + result.isShownAt.values[0].uri + '" target="blank">' + findByLangAgent(lang, result.dataProvider.values) + '</a></div></div>')
        }
      } else if (result.isShownAt.values[0].text !== undefined && result.isShownAt.values[0].text.length > 0) {
        if (result.isShownAt.values[0].text === 'Stockholm University') {
          htmlstr.push('<div class="spec spec-webpage"><div class="label" lang="en">Original webpage</div><div class="value">' +
            '<a href="' + result.isShownAt.values[0].uri + '" target="blank">Original website</a></div></div>')
        } else {
          htmlstr.push('<div class="spec spec-webpage"><div class="label" lang="en">Original webpage</div><div class="value">' +
            '<a href="' + result.isShownAt.values[0].uri + '" target="blank">' + result.isShownAt.values[0].text + '</a></div></div>')
        }
      } else {
        if (result.isShownAt.values[0].uri === 'Stockholm University') {
          htmlstr.push('<div class="spec spec-webpage"><div class="label" lang="en">Original webpage</div><div class="value">' +
            '<a href="' + result.isShownAt.values[0].uri + '" target="blank">Original website</a></div></div>')
        } else {
          htmlstr.push('<div class="spec spec-webpage"><div class="label" lang="en">Original webpage</div><div class="value">' +
            '<a href="' + result.isShownAt.values[0].uri + '" target="blank">' + result.isShownAt.values[0].uri + '</a></div></div>')
        }
      }
    }
  }

  let divprovider = []
  if (result.dataProvider !== undefined) {
    let providertext = ''
    let providerimage = ''
    let link = null
    if (result.dataProvider !== undefined) {
      providertext = findByLangAgent(lang, result.dataProvider.values)
      providerimage = findProviderImage(providertext)
      link = findProviderLink(providertext)
      // link = providertext.match(/href="([^"]*)/)
    }
    divprovider.push('<div class="spec"><div class="label" lang="en">Content Provider</div>')
    if (providerimage.length > 0) {
      divprovider.push('<div class="image"><div class="graphic">' +
        (link && link[1] ? '<a href="' + link + '" target="_blank">' : '') +
        '<img src="/static/' +
        providerimage.replace('/static/provider/', 'providers/') + '">' +
        (link && link[1] ? '</a>' : '') +
        '</div></div>')
    }

    divprovider.push('<div class="value">' + findByLangAgent(lang, result.dataProvider.values) + '</div></div>')

    if (result.dataProvider.values[0].prefLabel.values[0] !== undefined) {
      itemprovider = result.dataProvider.values[0].prefLabel.values[0].text
    }
  }

  let imageList = false
  if (result.hasView !== undefined && result.hasView.values.length > 1) {
    imageList = result.hasView.values
  } else if (result.isShownBy !== undefined && result.isShownBy.values.length > 0) {
    imageList = result.isShownBy.values
  }

  let media
  let item
  let pdfs
  if (imageList) {
    media = []
    pdfs = []

    // split media & pdf
    for (let i = 0, iLen = imageList.length; i < iLen; i++) {
      item = imageList[i]

      if (endsWith(item.uri, 'pdf')) {
        pdfs.push(item)
      }

      if (/player\.vimeo\.com/.test(item.uri)) {
        media.push(item)
      } else {
        media.push(Object.assign({}, item, {
          uri: item.reposUri
        }))
      }
    }
  }
  /*
    initSocialLinks(location.href, doctitle)

    let container
    if (itemtype.length > 0) {
      container = $("#tabSimObjects").find("div.wrap")
      findSimilarList(container, itemtype, "objectType", "fashion")
    } else {
      container = $("#tabSimObjects").css("display", "none")
      $('a[href="#tabSimObjects"]').parent().css("display", "none")
    }
    if (itemcreator.length > 0) {
      container = $("#tabSimCreator").find("div.wrap")
      findSimilarList(container, "", "", itemcreator)
    } else {
      container = $("#tabSimCreator").css("display", "none")
      $('a[href="#tabSimCreator"]').parent().css("display", "none")

    }
    if (itemprovider.length > 0) {
      container = $("#tabSimProvider").find("div.wrap")
      findSimilarList(container, itemprovider, "dataProviders", "fashion")
    } else {
      container = $("#tabSimProvider").css("display", "none")
    }
    */

  let itemSimilarObjectType = null
  let itemSimilarCreator = null
  let itemSimilarProvider = null

  if (itemtype.length > 0) {
    itemSimilarObjectType = findSimilarList(itemtype, 'objectType', 'fashion')
  }
  if (itemcreator.length > 0) {
    itemSimilarCreator = findSimilarList('', '', itemcreator)
  }
  if (itemprovider.length > 0) {
    itemSimilarProvider = findSimilarList(itemprovider, 'dataProviders', 'fashion')
  }

  let similar = {
    ...itemSimilarProvider,
    ...itemSimilarObjectType,
    ...itemSimilarCreator
  }

  return {
    itemtype,
    itemprovider,
    itemcreator,
    htmlstr,
    divprovider,
    imageList,
    pdfs,
    media,
    similar
  }
}

export const findSimilarList = function (relvalue, filtertype, term) {
  let searchjson = {
    'term': term,
    'count': 10,
    'offset': 0,
    'filters': [{'value': '' + relvalue + '', 'type': '' + filtertype + ''}]
  }

  if (filtertype.length === 0) {
    searchjson = {'term': term, 'count': 10, 'offset': 0, 'filters': []}
  }

  let similarcache = {results: []}
  let navlink = 'similar' + term + '10' + relvalue + filtertype
  if (localStorage.getCacheItem('similar' + term + '10' + relvalue + filtertype)) {
    return localStorage.getCacheItem('similar' + term + '10' + relvalue + filtertype).results
  } else {
    axios.post(
      'https://portal.fashionheritage.eu/api/search/',
      searchjson
    ).then(resultList => {
      let results = resultList.data

      if (results !== undefined && results.results !== undefined && results.results.length > 0) {
        results = results.results
        similarcache.results = results
        similarcache.total = results.total

        similarcache.results.map(e => {
          e.id = e.id + '#' + navlink
        })

        localStorage.setCacheItem('similar' + term + '10' + relvalue + filtertype, similarcache, {minutes: 10})

        return similarcache.results
      }
    })
  }
}

export const findByLangValues = function (sellang, array) {
  let selvalue = ''

  for (let i = 0; i < array.length; i++) {
    if (array[i].lang !== undefined && array[i].lang === sellang) {
      if (selvalue.length > 0) {
        selvalue += ', '
      }
      if (array[i].uri !== undefined && array[i].uri.length > 0) {
        if (array[i].text !== undefined && array[i].text.length > 0) {
          selvalue += '<a href="' + array[i].uri + '" target="blank">' + array[i].text + '</a>'
        } else {
          selvalue += '<a href="' + array[i].uri + '" target="blank">' + array[i].uri + '</a>'
        }
      } else if (array[i].text !== undefined) {
        selvalue += array[i].text
      }
    }
  }
  if (selvalue.length > 0) {
    return selvalue
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i].lang !== undefined && array[i].lang === 'en') {
      if (selvalue.length > 0) {
        selvalue += ', '
      }
      if (array[i].uri !== undefined && array[i].uri.length > 0) {
        if (array[i].text !== undefined && array[i].text.length > 0) {
          selvalue += '<a href="' + array[i].uri + '" target="blank">' + array[i].text + '</a>'
        } else {
          selvalue += '<a href="' + array[i].uri + '" target="blank">' + array[i].uri + '</a>'
        }
      } else if (array[i].text !== undefined) {
        selvalue += array[i].text
      }
    }
  }
  if (selvalue.length > 0) {
    return selvalue
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i].text !== undefined && (array[i].text.length > 0 || array[i].uri.length > 0)) {
      if (selvalue.length > 0) {
        selvalue += ', '
      }
      if (array[i].uri !== undefined && array[i].uri.length > 0) {
        if (array[i].text !== undefined && array[i].text.length > 0) {
          selvalue += '<a href="' + array[i].uri + '" target="blank">' + array[i].text + '</a>'
        } else {
          selvalue += '<a href="' + array[i].uri + '" target="blank">' + array[i].uri + '</a>'
        }
      } else if (array[i].text !== undefined) {
        selvalue += array[i].text
      }
    }
  }

  return selvalue
}

export const findByLangRights = function (sellang, array) {
  let selvalue = ''

  for (let i = 0; i < array.length; i++) {
    if (array[i].lang !== undefined && array[i].lang === sellang) {
      if (selvalue.length > 0) {
        selvalue += ', '
      }
      if (array[i].uri !== undefined && array[i].uri.length > 0) {
        if (array[i].text !== undefined && array[i].text.length > 0) {
          selvalue += array[i].uri
        } else {
          selvalue += array[i].uri
        }
      } else if (array[i].text !== undefined) {
        selvalue += array[i].text
      }
    }
  }
  if (selvalue.length > 0) {
    return selvalue
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i].lang !== undefined && array[i].lang === 'en') {
      if (selvalue.length > 0) {
        selvalue += ', '
      }
      if (array[i].uri !== undefined && array[i].uri.length > 0) {
        selvalue += array[i].uri
      } else if (array[i].text !== undefined) {
        selvalue += array[i].text
      }
    }
  }
  if (selvalue.length > 0) {
    return selvalue
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i].text !== undefined && (array[i].text.length > 0 || array[i].uri.length > 0)) {
      if (selvalue.length > 0) {
        selvalue += ', '
      }
      if (array[i].uri !== undefined && array[i].uri.length > 0) {
        selvalue += array[i].uri
      } else if (array[i].text !== undefined) {
        selvalue += array[i].text
      }
    }
  }

  return selvalue
}

function findByLangThesauriValues (sellang, array) {
  let selvalue = ''
  for (let i = 0; i < array.length; i++) {
    if (array[i].name !== undefined) {
      for (let j = 0; j < array[i].name.length; j++) {
        if (array[i].name[j].lang !== undefined && array[i].name[j].lang === sellang) {
          if (array[i].name[j].text !== undefined) {
            if (selvalue.length > 0) {
              selvalue += ', '
            }
            selvalue += array[i].name[j].text
          }
        }
      }
    }
  }
  if (selvalue.length > 0) {
    return selvalue
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i].name !== undefined) {
      for (let j = 0; j < array[i].name.length; j++) {
        if (array[i].name[j].lang !== undefined && array[i].name[j].lang === 'en') {
          if (array[i].name[j].text !== undefined) {
            if (selvalue.length > 0) {
              selvalue += ', '
            }
            selvalue += array[i].name[j].text
          }
        }
      }
    }
  }
  if (selvalue.length > 0) {
    return selvalue
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i].name !== undefined) {
      for (let j = 0; j < array[i].name.length; j++) {
        if (array[i].name[j].text !== undefined && array[i].name[j].text.length > 0) {
          if (array[i].name[j].text !== undefined) {
            if (selvalue.length > 0) {
              selvalue += ', '
            }
            selvalue += array[i].name[j].text
          }
        }
      }
    }
  }

  return selvalue
}

export const findByLangSpatial = function (sellang, array) {
  let selvalue = ''
  for (let i = 0; i < array.length; i++) {
    if (array[i].prefLabel !== undefined) {
      for (let j = 0; j < array[i].prefLabel.values.length; j++) {
        if (array[i].prefLabel.values[j].lang !== undefined && array[i].prefLabel.values[j].lang === sellang) {
          if (array[i].prefLabel.values[j].text !== undefined) {
            if (selvalue.length > 0) {
              selvalue += ', '
            }
            selvalue += array[i].prefLabel.values[j].text
          }
        }
      }
    }
    if (array[i].altLabel !== undefined) {
      for (let j = 0; j < array[i].altLabel.values.length; j++) {
        if (array[i].altLabel.values[j].lang === sellang) {
          if (array[i].altLabel.values[j].text !== undefined) {
            if (selvalue.length > 0) {
              selvalue += ', '
            }
            selvalue += array[i].altLabel.values[j].text
          }
        }
      }
    }
  }

  if (selvalue.length > 0) {
    return selvalue
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i].prefLabel !== undefined) {
      for (let j = 0; j < array[i].prefLabel.values.length; j++) {
        if (array[i].prefLabel.values[j].lang !== undefined && array[i].prefLabel.values[j].lang === 'en') {
          if (array[i].prefLabel.values[j].text !== undefined) {
            if (selvalue.length > 0) {
              selvalue += ', '
            }
            selvalue += array[i].prefLabel.values[j].text
          }
        }
      }
    }
    if (array[i].altLabel !== undefined) {
      for (let j = 0; j < array[i].altLabel.values.length; j++) {
        if (array[i].altLabel.values[j].lang === '') {
          if (array[i].altLabel.values[j].text !== undefined) {
            if (selvalue.length > 0) {
              selvalue += ', '
            }
            selvalue += array[i].altLabel.values[j].text
          }
        }
      }
    }
  }
  if (selvalue.length > 0) {
    return selvalue
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i].prefLabel !== undefined) {
      for (let j = 0; j < array[i].prefLabel.values.length; j++) {
        if (array[i].prefLabel.values[j].text !== undefined && array[i].prefLabel.values[j].text.length > 0) {
          if (array[i].prefLabel.values[j].text !== undefined) {
            if (selvalue.length > 0) {
              selvalue += ', '
            }
            selvalue += array[i].prefLabel.values[j].text
          }
        }
      }
    }
    if (array[i].altLabel !== undefined) {
      for (let j = 0; j < array[i].altLabel.values.length; j++) {
        if (array[i].altLabel.values[j].lang === 'en') {
          if (array[i].altLabel.values[j].text !== undefined) {
            if (selvalue.length > 0) {
              selvalue += ', '
            }
            selvalue += array[i].altLabel.values[j].text
          }
        }
      }
    }
  }

  return selvalue
}

export const findByLangAgent = function (sellang, array) {
  let selvalue = ''
  for (let i = 0; i < array.length; i++) {
    if (array[i].prefLabel !== undefined) {
      for (let j = 0; j < array[i].prefLabel.values.length; j++) {
        if ((array[i].prefLabel.values[j].lang !== undefined && array[i].prefLabel.values[j].lang === sellang) || array[i].prefLabel.values[j].lang === '') {
          if (array[i].prefLabel.values[j].text !== undefined) {
            if (selvalue.length > 0) {
              selvalue += ', '
            }
            if (array[i].homepage !== undefined && array[i].homepage.values !== undefined) {
              selvalue += '<a href="' + array[i].homepage.values[0].uri + '" target="blank">' + array[i].prefLabel.values[j].text + '</a>'
            } else {
              selvalue += array[i].prefLabel.values[j].text
            }
          }
        }
      }
    }
  }

  if (selvalue.length > 0) {
    return selvalue
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i].prefLabel !== undefined) {
      for (let j = 0; j < array[i].prefLabel.values.length; j++) {
        if (array[i].prefLabel.values[j].lang !== undefined && array[i].prefLabel.values[j].lang === 'en') {
          if (array[i].prefLabel.values[j].text !== undefined) {
            if (selvalue.length > 0) {
              selvalue += ', '
            }
            if (array[i].homepage !== undefined && array[i].homepage.values !== undefined) {
              selvalue += '<a href="' + array[i].homepage.values[0].uri + '" target="blank">' + array[i].prefLabel.values[j].text + '</a>'
            } else {
              selvalue += array[i].prefLabel.values[j].text
            }
          }
        }
      }
    }
  }

  if (selvalue.length > 0) {
    return selvalue
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i].prefLabel !== undefined) {
      for (let j = 0; j < array[i].prefLabel.values.length; j++) {
        if (array[i].prefLabel.values[j].text !== undefined && array[i].prefLabel.values[j].text.length > 0) {
          if (array[i].prefLabel.values[j].text !== undefined) {
            if (selvalue.length > 0) {
              selvalue += ', '
            }
            if (array[i].homepage !== undefined && array[i].homepage.values !== undefined) {
              selvalue += '<a href="' + array[i].homepage.values[0].uri + '" target="blank">' + array[i].prefLabel.values[j].text + '</a>'
            } else {
              selvalue += array[i].prefLabel.values[j].text
            }
          }
        }
      }
    }
  }
}

export const findByLangTitle = function (sellang, result) {
  let selvalue = ''
  let array
  let newval
  if (result.title !== undefined) {
    array = result.title.values
  } else if (result.description !== undefined) {
    array = result.description.values
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i].lang !== undefined && array[i].lang === sellang) {
      if (array[i].uri !== undefined && array[i].uri.length > 0) {
        if (array[i].text !== undefined && array[i].text.length > 0) {
          newval = array[i].text

          selvalue = '<a href="' + array[i].uri + '" target="blank">' + newval + '</a>'
          break
        } else {
          selvalue = '<a href="' + array[i].uri + '" target="blank">' + array[i].uri + '</a>'
          break
        }
      } else if (array[i].text !== undefined) {
        newval = array[i].text

        selvalue = newval
        break
      }
    }
  }
  if (selvalue.length > 0) {
    return selvalue
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i].lang !== undefined && array[i].lang === 'en') {
      if (array[i].uri !== undefined && array[i].uri.length > 0) {
        if (array[i].text !== undefined && array[i].text.length > 0) {
          newval = array[i].text
          selvalue = '<a href="' + array[i].uri + '" target="blank">' + newval + '</a>'
          break
        } else {
          selvalue = '<a href="' + array[i].uri + '" target="blank">' + array[i].uri + '</a>'
          break
        }
      } else if (array[i].text !== undefined) {
        newval = array[i].text
        selvalue = newval
        break
      }
    }
  }
  if (selvalue.length > 0) {
    return selvalue
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i].text !== undefined && array[i].text.length > 0) {
      if (array[i].uri !== undefined && array[i].uri.length > 0) {
        if (array[i].text !== undefined && array[i].text.length > 0) {
          newval = array[i].text
          selvalue = '<a href="' + array[i].uri + '" target="blank">' + newval + '</a>'
          break
        } else {
          selvalue = '<a href="' + array[i].uri + '" target="blank">' + array[i].uri + '</a>'
          break
        }
      } else if (array[i].text !== undefined) {
        newval = array[i].text
        selvalue = newval
        break
      }
    }
  }

  return selvalue
}



// WEBPACK FOOTER //
// ./src/helpers/ported.js